module.exports = __webpack_public_path__ + "static/media/LOGO_BRANCA.d6e2062f.svg";